const popup = Array.from(document.getElementsByClassName("popup"))

if (popup.length > 0) {
  const closeButton = document.querySelector(".close-popup")
  let cookie
  let cookieId
  function showOnLoad(item) {
    cookieId = item.dataset.cookie_id
    cookie = Window.Cookies.get(cookieId + "-popup-hide-cookie")
    if (!cookie) {
      item.style.display = "block"
    }
    Window.Cookies.set(item.dataset.cookie_id + "-popup-hide-cookie", true, { expires: 7 })
  }

  function closePopup(item) {
    item.style.display = "none"
  }

  if (popup.length > 0 && closeButton) {
    window.addEventListener(
      "load",
      (event) => {
        popup.forEach((item) => showOnLoad(item))
      },
      closeButton.addEventListener("click", function () {
        popup.forEach((item) => closePopup(item))
      }),
    )
  }
}
